import React from 'react';
import './Footer.css';
import Logo from '../UI/Logo';
const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-logo">
            <Logo imagePath="/logo_kvadro_text.png" width={150} height={40} />
          </div>
          
          <div className="footer-links">
            <a href="#why">Преимущества</a>
            <a href="#demo">Демо</a>
            <a href="#benefits">Выгода</a>
            <a href="#pricing">Тарифы</a>
            <a href="#contact">Контакты</a>
          </div>
        </div>
        
        <div className="copyright">
          &copy; {currentYear} KVADRO. Все права защищены.
        </div>
      </div>
    </footer>
  );
};

export default Footer;